(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.index = factory());
}(this, (function () { 'use strict';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var es6Promise = createCommonjsModule(function (module, exports) {
  /*!
   * @overview es6-promise - a tiny implementation of Promises/A+.
   * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
   * @license   Licensed under MIT license
   *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
   * @version   v4.2.5+7f2b526d
   */
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {

    function objectOrFunction(x) {
      var type = typeof x;
      return x !== null && (type === 'object' || type === 'function');
    }

    function isFunction(x) {
      return typeof x === 'function';
    }

    var _isArray = void 0;

    if (Array.isArray) {
      _isArray = Array.isArray;
    } else {
      _isArray = function (x) {
        return Object.prototype.toString.call(x) === '[object Array]';
      };
    }

    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;

    var asap = function asap(callback, arg) {
      queue[len] = callback;
      queue[len + 1] = arg;
      len += 2;

      if (len === 2) {
        if (customSchedulerFn) {
          customSchedulerFn(flush);
        } else {
          scheduleFlush();
        }
      }
    };

    function setScheduler(scheduleFn) {
      customSchedulerFn = scheduleFn;
    }

    function setAsap(asapFn) {
      asap = asapFn;
    }

    var browserWindow = typeof window !== 'undefined' ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
    var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

    function useNextTick() {
      return function () {
        return process.nextTick(flush);
      };
    }

    function useVertxTimer() {
      if (typeof vertxNext !== 'undefined') {
        return function () {
          vertxNext(flush);
        };
      }

      return useSetTimeout();
    }

    function useMutationObserver() {
      var iterations = 0;
      var observer = new BrowserMutationObserver(flush);
      var node = document.createTextNode('');
      observer.observe(node, {
        characterData: true
      });
      return function () {
        node.data = iterations = ++iterations % 2;
      };
    }

    function useMessageChannel() {
      var channel = new MessageChannel();
      channel.port1.onmessage = flush;
      return function () {
        return channel.port2.postMessage(0);
      };
    }

    function useSetTimeout() {
      var globalSetTimeout = setTimeout;
      return function () {
        return globalSetTimeout(flush, 1);
      };
    }

    var queue = new Array(1000);

    function flush() {
      for (var i = 0; i < len; i += 2) {
        var callback = queue[i];
        var arg = queue[i + 1];
        callback(arg);
        queue[i] = undefined;
        queue[i + 1] = undefined;
      }

      len = 0;
    }

    function attemptVertx() {
      try {
        var vertx = Function('return this')().require('vertx');

        vertxNext = vertx.runOnLoop || vertx.runOnContext;
        return useVertxTimer();
      } catch (e) {
        return useSetTimeout();
      }
    }

    var scheduleFlush = void 0;

    if (isNode) {
      scheduleFlush = useNextTick();
    } else if (BrowserMutationObserver) {
      scheduleFlush = useMutationObserver();
    } else if (isWorker) {
      scheduleFlush = useMessageChannel();
    } else if (browserWindow === undefined && typeof commonjsRequire === 'function') {
      scheduleFlush = attemptVertx();
    } else {
      scheduleFlush = useSetTimeout();
    }

    function then(onFulfillment, onRejection) {
      var parent = this;
      var child = new this.constructor(noop);

      if (child[PROMISE_ID] === undefined) {
        makePromise(child);
      }

      var _state = parent._state;

      if (_state) {
        var callback = arguments[_state - 1];
        asap(function () {
          return invokeCallback(_state, child, callback, parent._result);
        });
      } else {
        subscribe(parent, child, onFulfillment, onRejection);
      }

      return child;
    }

    function resolve$1(object) {
      var Constructor = this;

      if (object && typeof object === 'object' && object.constructor === Constructor) {
        return object;
      }

      var promise = new Constructor(noop);
      resolve(promise, object);
      return promise;
    }

    var PROMISE_ID = Math.random().toString(36).substring(2);

    function noop() {}

    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    var TRY_CATCH_ERROR = {
      error: null
    };

    function selfFulfillment() {
      return new TypeError("You cannot resolve a promise with itself");
    }

    function cannotReturnOwn() {
      return new TypeError('A promises callback cannot return that same promise.');
    }

    function getThen(promise) {
      try {
        return promise.then;
      } catch (error) {
        TRY_CATCH_ERROR.error = error;
        return TRY_CATCH_ERROR;
      }
    }

    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
      try {
        then$$1.call(value, fulfillmentHandler, rejectionHandler);
      } catch (e) {
        return e;
      }
    }

    function handleForeignThenable(promise, thenable, then$$1) {
      asap(function (promise) {
        var sealed = false;
        var error = tryThen(then$$1, thenable, function (value) {
          if (sealed) {
            return;
          }

          sealed = true;

          if (thenable !== value) {
            resolve(promise, value);
          } else {
            fulfill(promise, value);
          }
        }, function (reason) {
          if (sealed) {
            return;
          }

          sealed = true;
          reject(promise, reason);
        }, 'Settle: ' + (promise._label || ' unknown promise'));

        if (!sealed && error) {
          sealed = true;
          reject(promise, error);
        }
      }, promise);
    }

    function handleOwnThenable(promise, thenable) {
      if (thenable._state === FULFILLED) {
        fulfill(promise, thenable._result);
      } else if (thenable._state === REJECTED) {
        reject(promise, thenable._result);
      } else {
        subscribe(thenable, undefined, function (value) {
          return resolve(promise, value);
        }, function (reason) {
          return reject(promise, reason);
        });
      }
    }

    function handleMaybeThenable(promise, maybeThenable, then$$1) {
      if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
        handleOwnThenable(promise, maybeThenable);
      } else {
        if (then$$1 === TRY_CATCH_ERROR) {
          reject(promise, TRY_CATCH_ERROR.error);
          TRY_CATCH_ERROR.error = null;
        } else if (then$$1 === undefined) {
          fulfill(promise, maybeThenable);
        } else if (isFunction(then$$1)) {
          handleForeignThenable(promise, maybeThenable, then$$1);
        } else {
          fulfill(promise, maybeThenable);
        }
      }
    }

    function resolve(promise, value) {
      if (promise === value) {
        reject(promise, selfFulfillment());
      } else if (objectOrFunction(value)) {
        handleMaybeThenable(promise, value, getThen(value));
      } else {
        fulfill(promise, value);
      }
    }

    function publishRejection(promise) {
      if (promise._onerror) {
        promise._onerror(promise._result);
      }

      publish(promise);
    }

    function fulfill(promise, value) {
      if (promise._state !== PENDING) {
        return;
      }

      promise._result = value;
      promise._state = FULFILLED;

      if (promise._subscribers.length !== 0) {
        asap(publish, promise);
      }
    }

    function reject(promise, reason) {
      if (promise._state !== PENDING) {
        return;
      }

      promise._state = REJECTED;
      promise._result = reason;
      asap(publishRejection, promise);
    }

    function subscribe(parent, child, onFulfillment, onRejection) {
      var _subscribers = parent._subscribers;
      var length = _subscribers.length;
      parent._onerror = null;
      _subscribers[length] = child;
      _subscribers[length + FULFILLED] = onFulfillment;
      _subscribers[length + REJECTED] = onRejection;

      if (length === 0 && parent._state) {
        asap(publish, parent);
      }
    }

    function publish(promise) {
      var subscribers = promise._subscribers;
      var settled = promise._state;

      if (subscribers.length === 0) {
        return;
      }

      var child = void 0,
          callback = void 0,
          detail = promise._result;

      for (var i = 0; i < subscribers.length; i += 3) {
        child = subscribers[i];
        callback = subscribers[i + settled];

        if (child) {
          invokeCallback(settled, child, callback, detail);
        } else {
          callback(detail);
        }
      }

      promise._subscribers.length = 0;
    }

    function tryCatch(callback, detail) {
      try {
        return callback(detail);
      } catch (e) {
        TRY_CATCH_ERROR.error = e;
        return TRY_CATCH_ERROR;
      }
    }

    function invokeCallback(settled, promise, callback, detail) {
      var hasCallback = isFunction(callback),
          value = void 0,
          error = void 0,
          succeeded = void 0,
          failed = void 0;

      if (hasCallback) {
        value = tryCatch(callback, detail);

        if (value === TRY_CATCH_ERROR) {
          failed = true;
          error = value.error;
          value.error = null;
        } else {
          succeeded = true;
        }

        if (promise === value) {
          reject(promise, cannotReturnOwn());
          return;
        }
      } else {
        value = detail;
        succeeded = true;
      }

      if (promise._state !== PENDING) {} else if (hasCallback && succeeded) {
        resolve(promise, value);
      } else if (failed) {
        reject(promise, error);
      } else if (settled === FULFILLED) {
        fulfill(promise, value);
      } else if (settled === REJECTED) {
        reject(promise, value);
      }
    }

    function initializePromise(promise, resolver) {
      try {
        resolver(function resolvePromise(value) {
          resolve(promise, value);
        }, function rejectPromise(reason) {
          reject(promise, reason);
        });
      } catch (e) {
        reject(promise, e);
      }
    }

    var id = 0;

    function nextId() {
      return id++;
    }

    function makePromise(promise) {
      promise[PROMISE_ID] = id++;
      promise._state = undefined;
      promise._result = undefined;
      promise._subscribers = [];
    }

    function validationError() {
      return new Error('Array Methods must be provided an Array');
    }

    var Enumerator = function () {
      function Enumerator(Constructor, input) {
        this._instanceConstructor = Constructor;
        this.promise = new Constructor(noop);

        if (!this.promise[PROMISE_ID]) {
          makePromise(this.promise);
        }

        if (isArray(input)) {
          this.length = input.length;
          this._remaining = input.length;
          this._result = new Array(this.length);

          if (this.length === 0) {
            fulfill(this.promise, this._result);
          } else {
            this.length = this.length || 0;

            this._enumerate(input);

            if (this._remaining === 0) {
              fulfill(this.promise, this._result);
            }
          }
        } else {
          reject(this.promise, validationError());
        }
      }

      Enumerator.prototype._enumerate = function _enumerate(input) {
        for (var i = 0; this._state === PENDING && i < input.length; i++) {
          this._eachEntry(input[i], i);
        }
      };

      Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
        var c = this._instanceConstructor;
        var resolve$$1 = c.resolve;

        if (resolve$$1 === resolve$1) {
          var _then = getThen(entry);

          if (_then === then && entry._state !== PENDING) {
            this._settledAt(entry._state, i, entry._result);
          } else if (typeof _then !== 'function') {
            this._remaining--;
            this._result[i] = entry;
          } else if (c === Promise$1) {
            var promise = new c(noop);
            handleMaybeThenable(promise, entry, _then);

            this._willSettleAt(promise, i);
          } else {
            this._willSettleAt(new c(function (resolve$$1) {
              return resolve$$1(entry);
            }), i);
          }
        } else {
          this._willSettleAt(resolve$$1(entry), i);
        }
      };

      Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
        var promise = this.promise;

        if (promise._state === PENDING) {
          this._remaining--;

          if (state === REJECTED) {
            reject(promise, value);
          } else {
            this._result[i] = value;
          }
        }

        if (this._remaining === 0) {
          fulfill(promise, this._result);
        }
      };

      Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
        var enumerator = this;
        subscribe(promise, undefined, function (value) {
          return enumerator._settledAt(FULFILLED, i, value);
        }, function (reason) {
          return enumerator._settledAt(REJECTED, i, reason);
        });
      };

      return Enumerator;
    }();

    function all(entries) {
      return new Enumerator(this, entries).promise;
    }

    function race(entries) {
      var Constructor = this;

      if (!isArray(entries)) {
        return new Constructor(function (_, reject) {
          return reject(new TypeError('You must pass an array to race.'));
        });
      } else {
        return new Constructor(function (resolve, reject) {
          var length = entries.length;

          for (var i = 0; i < length; i++) {
            Constructor.resolve(entries[i]).then(resolve, reject);
          }
        });
      }
    }

    function reject$1(reason) {
      var Constructor = this;
      var promise = new Constructor(noop);
      reject(promise, reason);
      return promise;
    }

    function needsResolver() {
      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }

    function needsNew() {
      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }

    var Promise$1 = function () {
      function Promise(resolver) {
        this[PROMISE_ID] = nextId();
        this._result = this._state = undefined;
        this._subscribers = [];

        if (noop !== resolver) {
          typeof resolver !== 'function' && needsResolver();
          this instanceof Promise ? initializePromise(this, resolver) : needsNew();
        }
      }

      Promise.prototype.catch = function _catch(onRejection) {
        return this.then(null, onRejection);
      };

      Promise.prototype.finally = function _finally(callback) {
        var promise = this;
        var constructor = promise.constructor;

        if (isFunction(callback)) {
          return promise.then(function (value) {
            return constructor.resolve(callback()).then(function () {
              return value;
            });
          }, function (reason) {
            return constructor.resolve(callback()).then(function () {
              throw reason;
            });
          });
        }

        return promise.then(callback, callback);
      };

      return Promise;
    }();

    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;

    function polyfill() {
      var local = void 0;

      if (typeof commonjsGlobal !== 'undefined') {
        local = commonjsGlobal;
      } else if (typeof self !== 'undefined') {
        local = self;
      } else {
        try {
          local = Function('return this')();
        } catch (e) {
          throw new Error('polyfill failed because global object is unavailable in this environment');
        }
      }

      var P = local.Promise;

      if (P) {
        var promiseToString = null;

        try {
          promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {}

        if (promiseToString === '[object Promise]' && !P.cast) {
          return;
        }
      }

      local.Promise = Promise$1;
    }

    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
  });
});

function promiseCallback(result) {
  var fn = function fn() {};

  var promise = new es6Promise(function (resolve) {
    fn = function fn(data) {
      return resolve(data);
    };
  });
  fn.promise = promise;

  if (result) {
    fn.promise = es6Promise.resolve(result);
  }

  return fn;
}

function encodeBase64andURI(string) {
  return btoa(encodeURIComponent(string).replace(/%(..)/ig, function (_, hex) {
    return String.fromCharCode(parseInt(hex, 16));
  }));
}

var JSBridge =
/*#__PURE__*/
function () {
  function JSBridge() {
    this.bridgeScheme = 'nativeapp://';
    this.dispatchMsgPath = 'dispatch_message/';
    this.setResultPath = 'private/setresult/';
    this.fetchQueue = 'SCENE_FETCHQUEUE';
    this.jsBridgeKey = 'JSBridge';
    this.callbackId = 1000;
    this.callbackMap = {};
    this.eventHookMap = {};
    this.sendMessageQueue = [];
    this.fallbackCheckFunction = null;
  }

  var _proto = JSBridge.prototype;

  _proto._fetchQueue = function _fetchQueue() {
    var messageQueueString = JSON.stringify(this.sendMessageQueue);

    if (this.sendMessageQueue.length > 0) {
      this._dispatchUrlMsg("" + this.bridgeScheme + this.setResultPath + this.fetchQueue + "&" + encodeBase64andURI(messageQueueString));
    }

    this.sendMessageQueue = [];
    return messageQueueString;
  };

  _proto._dispatchUrlMsg = function _dispatchUrlMsg(url) {
    if (typeof document !== 'undefined') {
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      iframe.src = url;
      setTimeout(function () {
        document.body.removeChild(iframe);
      }, 300);
    }
  };

  _proto._handleMessageFromApp = function _handleMessageFromApp(message) {
    var params = message['__params'];
    var ret = {
      __err_code: 'cb404'
    };
    var callbackId = message['__callback_id'];

    if (typeof callbackId === 'string' && typeof this.callbackMap[callbackId] === 'function') {
      ret = this.callbackMap[callbackId](params);
      delete this.callbackMap[callbackId];
    } else if (typeof callbackId === 'string' && Array.isArray(this.eventHookMap[callbackId])) {
      this.eventHookMap[callbackId].forEach(function (handler) {
        if (typeof handler === 'function') {
          ret = handler(params);
        }
      });
    }

    return JSON.stringify(ret);
  };

  _proto._call = function _call(func, params, callback, sdkVersion, fromInnerOn) {
    if (params === void 0) {
      params = {};
    }

    if (callback === void 0) {
      callback = null;
    }

    if (sdkVersion === void 0) {
      sdkVersion = 3;
    }

    if (fromInnerOn === void 0) {
      fromInnerOn = 0;
    }

    if (!func || typeof func !== 'string') {
      return;
    }

    if (this.fallbackCheckFunction && this.fallbackCallFunction && this.fallbackCheckFunction(func)) {
      return this.fallbackCallFunction(func, params, callback, sdkVersion);
    }

    var callbackID;

    if (fromInnerOn) {
      callbackID = func;
    } else {
      this.callbackId += 1;
      callbackID = this.callbackId.toString();
    }

    var useSync = params && params.jsb_sync;
    var fn = callback;

    if (typeof fn === 'function') {
      this.callbackMap[callbackID] = fn;
    } else if (!useSync && !fromInnerOn) {
      fn = promiseCallback();
      this.callbackMap[callbackID] = fn;
    }

    var msgJSON = {
      JSSDK: sdkVersion,
      func: func,
      params: params,
      __msg_type: fromInnerOn ? 'event' : 'call',
      __callback_id: callbackID
    };

    if (useSync) {
      delete params.jsb_sync;
    }

    var response;

    try {
      if (useSync && window.JS2NativeBridge && window.JS2NativeBridge.callSync) {
        msgJSON.currentUrl = window.location.href;
        response = window.JS2NativeBridge.callSync(func, JSON.stringify(msgJSON));
      } else if (window.JS2NativeBridge && window.JS2NativeBridge.call) {
        response = window.JS2NativeBridge.call(func, JSON.stringify(msgJSON));
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callMethodParams) {
        response = window.webkit.messageHandlers.callMethodParams.postMessage(msgJSON);
      } else if (window.callMethodParams) {
        response = window.callMethodParams(func, msgJSON);
      } else {
        this.sendMessageQueue.push(msgJSON);

        this._dispatchUrlMsg("" + this.bridgeScheme + this.dispatchMsgPath);
      }
    } catch (e) {
      console.error(e);
    }

    return fn && fn.promise || response;
  };

  _proto._on = function _on(event, callback, sdkVersion) {
    if (sdkVersion === void 0) {
      sdkVersion = 3;
    }

    if (!event || typeof event !== 'string' || typeof callback !== 'function') {
      return;
    }

    if (this.fallbackCheckFunction && this.fallbackOnFunction && this.fallbackCheckFunction(event)) {
      this.fallbackOnFunction(event, callback, sdkVersion);
      return;
    }

    if (this.eventHookMap[event]) {
      this.eventHookMap[event].push(callback);
    } else {
      this.eventHookMap[event] = [callback];
    }

    var msgJSON = {
      JSSDK: sdkVersion,
      __msg_type: 'event',
      __callback_id: event,
      func: event
    };

    try {
      if (window.JS2NativeBridge && window.JS2NativeBridge.on) {
        window.JS2NativeBridge.on(event, JSON.stringify(msgJSON));
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.onMethodParams) {
        window.webkit.messageHandlers.onMethodParams.postMessage(msgJSON);
      } else if (window.onMethodParams) {
        window.onMethodParams(event, msgJSON);
      } else if (!window.JS2NativeBridge) {
        this._call(event, {}, null, sdkVersion, 1);
      }
    } catch (e) {
      console.error(e);
    }
  };

  _proto._off = function _off(event, callback) {
    if (!event || typeof event !== 'string' || typeof callback !== 'function') {
      return;
    }

    if (this.fallbackCheckFunction && this.fallbackOffFunction && this.fallbackCheckFunction(event)) {
      this.fallbackOffFunction(event, callback);
      return;
    }

    if (this.eventHookMap[event]) {
      this.eventHookMap[event] = this.eventHookMap[event].filter(function (_callback) {
        return _callback !== callback;
      });
    }
  };

  _proto._trigger = function _trigger(event, msgParams) {
    if (this.fallbackCheckFunction && this.fallbackTriggerFunction && this.fallbackCheckFunction(event)) {
      this.fallbackTriggerFunction(event, msgParams);
      return;
    }

    var eventQueue = this.eventHookMap[event];
    var called = false;

    if (eventQueue) {
      for (var i = 0, len = eventQueue.length; i < len; i++) {
        var callback = eventQueue[i];

        if (typeof callback === 'function') {
          called = true;
          callback(msgParams);
        }
      }
    }

    return called;
  };

  _proto._config = function _config(options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    if (options.jsBridgeKey && typeof window !== 'undefined') {
      if (!window[options.jsBridgeKey]) {
        window[options.jsBridgeKey] = {};
      }

      window[options.jsBridgeKey]['call'] = function () {
        return _this._call.apply(_this, arguments);
      };

      window[options.jsBridgeKey]['on'] = function () {
        return _this._on.apply(_this, arguments);
      };

      window[options.jsBridgeKey]['off'] = function () {
        return _this._off.apply(_this, arguments);
      };

      window[options.jsBridgeKey]['trigger'] = function () {
        return _this._trigger.apply(_this, arguments);
      };
    }

    if (options.fallbackCheckFunction && typeof options.fallbackCheckFunction === 'function') {
      this.fallbackCheckFunction = options.fallbackCheckFunction;
    }

    if (options.fallbackCallFunction && typeof options.fallbackCallFunction === 'function') {
      this.fallbackCallFunction = options.fallbackCallFunction;
    }

    if (options.fallbackOnFunction && typeof options.fallbackOnFunction === 'function') {
      this.fallbackOnFunction = options.fallbackOnFunction;
    }

    if (options.fallbackOffFunction && typeof options.fallbackOffFunction === 'function') {
      this.fallbackOffFunction = options.fallbackOffFunction;
    }

    if (options.fallbackTriggerFunction && typeof options.fallbackTriggerFunction === 'function') {
      this.fallbackTriggerFunction = options.fallbackTriggerFunction;
    }
  };

  _proto.init = function init() {
    var _this2 = this;

    var jsbridge = {
      call: function call() {
        return _this2._call.apply(_this2, arguments);
      },
      on: function on() {
        return _this2._on.apply(_this2, arguments);
      },
      off: function off() {
        return _this2._off.apply(_this2, arguments);
      },
      trigger: function trigger() {
        return _this2._trigger.apply(_this2, arguments);
      },
      config: function config() {
        return _this2._config.apply(_this2, arguments);
      }
    };

    if (typeof window !== 'undefined') {
      if (!window.Native2JSBridge && !window.JSBridge) {
        window.Native2JSBridge = {
          _fetchQueue: function _fetchQueue() {
            return _this2._fetchQueue.apply(_this2, arguments);
          },
          _handleMessageFromApp: function _handleMessageFromApp() {
            return _this2._handleMessageFromApp.apply(_this2, arguments);
          }
        };
        window.JSBridge = jsbridge;
      } else {
        jsbridge = window.JSBridge;
      }
    }

    return jsbridge;
  };

  return JSBridge;
}();

var JSBInstance = new JSBridge();
var index = JSBInstance.init();

return index;

})));
